import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from 'helpers/api'
import { toast } from "react-toastify";
import { t } from 'i18next';

export const userReviews = createAsyncThunk('review/user', async (params, { dispatch }) => {
  try {
    const response = await api.get("mobile/review/user/" + params);
    if (!response.data.Result) {
      toast.error(t(`api.errors.${response?.data?.Code}`));
    }
    return response?.data;
  } catch (error) {
    toast.error(t('api.errors.error'));
    throw error;
  }
})

export const reviewDetails = createAsyncThunk('review/details', async (params, { dispatch }) => {
  try {
    const response = await api.get("mobile/review/details/" + params);
    if (!response.data.Result) {
      toast.error(t(`api.errors.${response?.data?.Code}`));
    }
    return response?.data;
  } catch (error) {
    toast.error(t('api.errors.error'));
    throw error;
  }
})

export const createReview = createAsyncThunk('review/new', async (params, { dispatch }) => {
  const config = { headers: { "Content-Type": "multipart/form-data" } };
  try {
    const response = await api.post("mobile/review/new", params, config);

    if (!response.data.Result) {
      toast.error(t(`api.errors.${response?.data?.Code}`));
    }

    return response?.data;

  } catch (error) {
    toast.error(t('api.errors.error'));
    throw error;
  }
})

const initialState = {
  user: false,
  selected: false
};

export const reviewSlice = createSlice({
  name: "review",
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder.addCase(userReviews.fulfilled, (state, action) => {
      state.user = action.payload.Data
    })
    builder.addCase(reviewDetails.fulfilled, (state, action) => {
      state.selected = action.payload.Data
    })
  }
});

export default reviewSlice.reducer;
